// imports
import React from 'react';
import { Tooltip } from '@mui/material';
import PublicIcon from '@mui/icons-material/Public';

// local imports
import CustomButton from '../../CustomButton';
import { sharedTooltipProps } from '../CustomMapControls/sharedTooltipProps';

/**
 * MapResetButton
 *
 * Renders a button that resets the map to initial extent.
 *
 * @returns {JSX.Element} The rendered MapResetButton component.
 */

interface MapResetButtonProps {
  onResetView: () => void;
}

const MapResetButton = React.memo(function MapResetButton({ onResetView }: MapResetButtonProps) {
  return (
    <Tooltip title="Reset map view" placement="left" {...sharedTooltipProps}>
      <CustomButton
        data-testid="map-reset-button"
        aria-label="Reset map view"
        onClick={onResetView}
      >
        <PublicIcon />
      </CustomButton>
    </Tooltip>
  );
});

export default MapResetButton;
